import { memo } from "react";
import cx from "clsx";
import { EditorData } from "@smartsuite/types";
import { isDocEmpty } from "@smartsuite/smartdoc";

interface SmartDocRendererProps {
  className?: string;
  editorData: EditorData;
}

const SmartDocRendererRaw = ({
  className,
  editorData,
}: SmartDocRendererProps): JSX.Element | null => {
  const classes = cx(className, "editor-display ProseMirror ProseMirror--display");

  if (!editorData.html || isDocEmpty(editorData.data)) {
    return null;
  }

  return <div className={classes} dangerouslySetInnerHTML={{ __html: editorData.html }} />;
};

export const SmartDocRenderer = memo(SmartDocRendererRaw);
